import { styled } from '@linaria/react';

export const Container = styled.div`
	padding: 16px;
	border-radius: var(--radius-xs);
	background-color: var(--color-white-xs);
`;
